import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const InputIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="6" cy="8" r="2" fill={fillColor || '#9D9DA6'} />
      <path d="M6 8H14" stroke={fillColor || '#9D9DA6'} />
      <circle cx="6" cy="8" r="3.5" stroke="#9D9DA6" />
    </svg>
  );
};

export { InputIcon };
